module.exports = __webpack_public_path__ + "img/25_38.d4ebdfb9.png";